// Een 401 op een eigen account-endpoint betekent dat het token in de browser
// niet (meer) bij het account hoort. fetch.js meldt dat hier; de app logt dan
// uit en vraagt om opnieuw in te loggen.
const SESSION_EXPIRED = 'sb:session-expired';

// Lopende requests met het oude token geven vaak tegelijk een 401: één melding.
const QUIET_MS = 5000;
let lastNotified = 0;

export function notifySessionExpired() {
    if (typeof window === 'undefined') return;
    const now = Date.now();
    if (now - lastNotified < QUIET_MS) return;
    lastNotified = now;
    window.dispatchEvent(new Event(SESSION_EXPIRED));
}

export function onSessionExpired(handler) {
    window.addEventListener(SESSION_EXPIRED, handler);
    return () => window.removeEventListener(SESSION_EXPIRED, handler);
}
